// socket.js
import { io } from "socket.io-client";
import { getApiBaseUrl } from "./utils/baseUrl";

const SERVER_URL = getApiBaseUrl();

console.log("🌐 Connecting to Socket.IO backend at:", SERVER_URL);

const socket = io(SERVER_URL, {
  path: "/socket.io", // important for proxy
  transports: ["polling", "websocket"],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
});

// Debug logs (VERY IMPORTANT)
socket.on("connect", () => {
  console.log("✅ Socket connected:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.warn("⚠️ Socket disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.error("❌ Socket connection error:", err.message || err);
});

export default socket;
